import Icon from "../../assets/icons/Icon";
import { useEffect } from "react";
import Loading from "./Loading";

const AuditTrail = ({ data, loading }) => {
  const formatUTCDate = (isoString) => {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "Invalid date";

    const formattedDate = date.getUTCFullYear() + "-" +
                          String(date.getUTCMonth() + 1).padStart(2, "0") + "-" +
                          String(date.getUTCDate()).padStart(2, "0");

    const formattedTime = String(date.getUTCHours()).padStart(2, "0") + ":" +
                          String(date.getUTCMinutes()).padStart(2, "0") + ":" +
                          String(date.getUTCSeconds()).padStart(2, "0");

    return `${formattedDate} ${formattedTime}`;
  };


  const formatLocalDate = (isoString) => {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "Invalid date";

  const formattedDate =
    date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, "0") + "-" +
    String(date.getDate()).padStart(2, "0");

  const formattedTime =
    String(date.getHours()).padStart(2, "0") + ":" +
    String(date.getMinutes()).padStart(2, "0") + ":" +
    String(date.getSeconds()).padStart(2, "0");

  return `${formattedDate} ${formattedTime}`;
};
  const formatDate = (timestamp) => {
    if (!timestamp) return "Unknown date";

    // MongoDB ISO date string (or native JS date)
    if (typeof timestamp === "string" || timestamp instanceof Date) {
      return formatUTCDate(timestamp);
    }

    // Number (milliseconds) timestamp
    if (typeof timestamp === "number") {
      return formatLocalDate(new Date(timestamp).toISOString());
    }

    return "Unknown date format";
  };

  useEffect(() => {
    console.log("AuditTrail data:", data);
  }, [data]);

  const getActionColor = (action) => {
    switch (action?.toUpperCase()) {
      case "EDIT": return { bg: "bg-blue-500", text: "text-blue-600", icon: "edit" };
      case "AUTO EDIT": return { bg: "bg-purple-500", text: "text-purple-600", icon: "automatic" };
      case "LOGIN": return { bg: "bg-green-500", text: "text-green-600", icon: "login" };
      case "LOGOUT": return { bg: "bg-red-500", text: "text-red-600", icon: "logout" };
      case "CREATE": return { bg: "bg-teal-500", text: "text-teal-600", icon: "add" };
      case "DELETE": return { bg: "bg-rose-500", text: "text-rose-600", icon: "delete" };
      default: return { bg: "bg-gray-500", text: "text-gray-600", icon: "default" };
    }
  };

  return (
    <div className="max-w-4xl py-6 bg-white">
      {loading ? (
        <Loading />
      ) : data && data.length > 0 ? (
        <div className="space-y-4">
          {data.map((item, index) => {
            const { bg, text } = getActionColor(item.Action);
            return (
              <div key={item._id || index} className="flex">
                {/* Date/time */}
                <div className="lg:w-50 flex-shrink-0 mr-2 text-right pr-2 break-words text-[var(--list-item-gray)]">
                  {formatDate(item.ActionOn)}
                </div>

                {/* Timeline */}
                <div className="relative flex flex-col items-center w-6 flex-shrink-0">
                  <div className="absolute top-1 bottom-0 w-px bg-gray-300"></div>
                  <div className={`w-3 h-3 rounded-full ${bg} z-10 mt-1 flex-shrink-0`}></div>
                </div>

                {/* Audit content */}
                <div className="flex-1 min-w-0 pb-2 ml-2">
                  <div className="flex flex-col min-w-0">
                    <div className="flex items-center space-x-2 flex-wrap">
                      <span className={`font-medium ${text} break-words`}>
                        {item.Action}
                      </span>
                      <span className="text-[var(--list-item-gray)]">by</span>
                      <span className="font-medium break-words">
                        {item.ActionBy}
                      </span>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 mt-2">
                    <div className="grid grid-cols-1 gap-2 text-[14px]">
                      <div className="flex flex-wrap items-center gap-x-2">
                        <span className="text-[var(--list-item-gray)]">Email:</span>
                        <span className="text-black break-all">
                          {item.ActionByEmailID}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-[var(--list-item-gray)]">
          No audit data available
        </div>
      )}
    </div>
  );
};

export default AuditTrail;